<template>
  <div
    ref="ref"
    class="flex text-sm bg-gray-900 border border-gray-800 rounded-sm cursor-default t3m-ObjectiveFinder-filter text-t3m-body bg-opacity-10 border-opacity-10"
    :class="
      `t3m-ObjectiveFinder-filter--${filterOptionProperties.modifiers}`
    "
  >
    <div class="bg-gray-800 bg-opacity-10 px-1.5 pt-1.5 mr-1 relative">
      <svg
        class="w-[1.2em] h-[1.2em]"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
        fill="currentColor"
        v-if="filterOptionProperties.checked"
      >
        <path
          d="M384 32C419.3 32 448 60.65 448 96V416C448 451.3 419.3 480 384 480H64C28.65 480 0 451.3 0 416V96C0 60.65 28.65 32 64 32H384zM339.8 211.8C350.7 200.9 350.7 183.1 339.8 172.2C328.9 161.3 311.1 161.3 300.2 172.2L192 280.4L147.8 236.2C136.9 225.3 119.1 225.3 108.2 236.2C97.27 247.1 97.27 264.9 108.2 275.8L172.2 339.8C183.1 350.7 200.9 350.7 211.8 339.8L339.8 211.8z"
        />
      </svg>
      <svg
        class="text-white w-[1.2em] h-[1.2em]"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 448 512"
        fill="currentColor"
        v-else
      >
        <path
          d="M0 96C0 60.65 28.65 32 64 32H384C419.3 32 448 60.65 448 96V416C448 451.3 419.3 480 384 480H64C28.65 480 0 451.3 0 416V96z"
        />
      </svg>
      <input
        :id="myCheckboxId"
        :name="myCheckboxId"
        :data-filter-item-id="`t3m-ObjectiveFinder-filter-input--${filterOptionProperties.id || ''}`"
        type="checkbox"
        class="absolute top-0 left-0 w-8 opacity-0 custom-control-input h-full cursor-pointer"
        v-model="filterOptionProperties.checked"
      />
    </div>
    <label
      class="flex items-baseline justify-between px-1 py-1 space-x-2 grow cursor-pointer"
      :for="myCheckboxId"
    >
      <span class="t3m-ObjectiveFinder-filter-text">{{
        filterOptionProperties.label
      }}</span>
      <span
        class="text-xs t3m-ObjectiveFinder-filter-amount font-condensed text-t3m-muted"
        >{{ myShare }}</span
      >
    </label>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'FilterOption',
  data() {
    return {}
  },
  props: {
    filterOptionProperties: {
      type: Object,
      default: () => {},
    },
    filterItemID: String,
    filterItemTitle: String,
    filterType: String,
    targetProperty: String,
    logicalOperator: String,
    pid: Number,
    amountCheckedSiblings: Number,
  },
  computed: {
    ...mapState(['filteredObjectives', 'filterItems']),
    myShare: function() {
      let amount

      if (
        this.amountCheckedSiblings &&
        !this.filterOptionProperties.checked &&
        this.logicalOperator != 'AND'
      ) {
        return '+'
      }

      switch (this.filterType) {
        case 'array':
          amount = this.filteredObjectives.filter(obj => {
            return obj[this.targetProperty]
              ? obj[this.targetProperty].filter(v =>
                  Object.values(
                    this.filterOptionProperties.filterValues
                  ).includes(v)
                ).length
              : false
          }).length

          break

        case 'string':
          amount = this.filteredObjectives.filter(obj => {
            return Object.values(this.filterOptionProperties.filterValues).some(
              element => {
                return element === obj[this.targetProperty]
              }
            )
          }).length
          break

        case 'fuzzyString':
          amount = this.filteredObjectives.filter(obj => {
            return obj[this.targetProperty]
              .toString()
              .includes(
                Object.values(this.filterOptionProperties.filterValues)[0]
              )
          }).length
          break

        case 'float':
          amount = this.filteredObjectives.filter(obj => {
            return (
              Object.values(this.filterOptionProperties.filterValues)[0]
                .valueMin <= obj[this.targetProperty] &&
              Object.values(this.filterOptionProperties.filterValues)[0]
                .valueMax >= obj[this.targetProperty]
            )
          }).length
          break

        default:
          amount = undefined
          break
      }
      return amount
    },
    myCheckboxId: function() {
      return 'filter-checkbox-' + this._uid
    },
  },
  methods: {
    ...mapActions(['setLastFilterOption']),
  },
  watch: {
    'filterOptionProperties.checked': function() {
      this.$emit('change')

      let event = new CustomEvent('ofFilterCheck', {
        detail: {
          filterItemID: this.filterItemID,
          filterItemTitle: this.filterItemTitle,
          filterOptionTitle: this.filterOptionProperties.label,
          filterOptionValue: this.filterOptionProperties.checked,
        },
      })
      window.dispatchEvent(event)

      this.setLastFilterOption(this)
    },
  },
}
</script>
